<script setup>
import { computed } from 'vue';
import HeaderKeyValueInput from './HeaderKeyValueInput.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const model = defineModel({ default: () => [] });

const headers = computed(() => model.value);

const addHeader = () => {
  model.value = [...model.value, { key: '', value: '' }];
};

const updateHeader = (index, updatedHeader) => {
  const newHeaders = [...model.value];
  newHeaders[index] = updatedHeader;
  model.value = newHeaders;
};

const deleteHeader = index => {
  const newHeaders = model.value.filter((_, i) => i !== index);
  model.value = newHeaders.length ? newHeaders : [{ key: '', value: '' }];
};
</script>

<template>
  <div class="mt-2">
    <label class="mb-1 text-sm font-medium text-n-slate-12">
      {{ $t('AUTOMATION.ACTION.ADVANCED_WEBHOOK.HEADERS_LABEL') }}
    </label>
    <div class="space-y-2">
      <HeaderKeyValueInput
        v-for="(header, index) in headers"
        :key="index"
        :model-value="header"
        @update:model-value="updateHeader(index, $event)"
        @delete="deleteHeader(index)"
      />
      <NextButton icon="i-lucide-plus" sm slate ghost @click="addHeader">
        {{ $t('AUTOMATION.ACTION.ADVANCED_WEBHOOK.ADD_HEADER') }}
      </NextButton>
    </div>
  </div>
</template>
